// extracted by mini-css-extract-plugin
export default {"wrapper":"MenuTitleComponent_wrapper__CFch4","logoImage":"MenuTitleComponent_logoImage__bEeXs"};